import React, { Fragment } from "react"
import { Rules } from "@orbital/games-frontend-library"
import { GAME_RULES_PROPS } from "./interface"
import { GameplayCustomization, Settings } from "./CONTENT"
import GameDescription from "./GameDescription"

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function GameRulesChildren({
  colors,
  minBet,
  maxBet,
  currency,
}: GAME_RULES_PROPS): any {
  return (
    <Fragment>
      <GameDescription minBet={minBet} maxBet={maxBet} currency={currency} />
      <h3>Settings</h3>
      <Rules content={Settings} colors={colors} />
      <h3>Gameplay Customization</h3>
      <Rules content={GameplayCustomization} colors={colors} />
    </Fragment>
  )
}
